import Vue from "vue";

export default () => {
    Vue.directive("loadMore", {
        bind(el, binding) {
            var p = 0;
            var t = 0;
            var down = true;
            var selectWrap = el.querySelector(
                ".selectPhaseBox .el-scrollbar__wrap"
            );
            selectWrap.addEventListener("scroll", function () {
                //判断是否向下滚动
                p = this.scrollTop;
                if (t < p) {
                    down = true;
                } else {
                    down = false;
                }
                t = p;
                //判断是否到底
                const sign = 10;
                const scrollDistance =
                    this.scrollHeight - this.scrollTop - this.clientHeight;
                if (scrollDistance <= sign && down) {
                    binding.value();
                }
            });
        },
    }),
    Vue.directive("loadMoreData", {
        bind(el, binding) {
            const SELECTWRAP_DOM = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap");
            SELECTWRAP_DOM.addEventListener("scroll", function() {
                const CONDITION = this.scrollHeight - this.scrollTop <= this.clientHeight;
                if (CONDITION) {
                    binding.value();
                }
            });
        }
    });
}


// WEBPACK FOOTER //
// ./src/directives.js